<template>
  <v-autocomplete
  :items="filteredCertifications"
  return-object
  item-text="name"
  multiple
  chips
  id="certifications"
  :label="(label) ? selectLabel : undefined"
  :rules="rules"
  :hint="hint"
  :persistent-hint="hint !== ''"
  v-model="selectedCertifications"
  :menu-props="{
    contentClass: getMenuContentClass
  }">
    <template v-if="$scopedSlots.selection" #selection="data">
      <slot name="selection" v-bind="data"/>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Certifications',

  props: {
    propCertifications: {
      type: Array[Object],
      default: () => []
    },
    useIdOnly: {
      type: Boolean,
      default: false
    },
    category: {
      type: Number,
      required: true
    },
    label: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    propFetchCertifications: {
      type: Boolean,
      default: true,
      required: false
    },
    elementId: {
      type: String,
      required: false,
      default: undefined
    },
    rules: {
      type: Array,
      default: () => []
    },
    hint: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    selectedCertifications: []
  }),

  computed: {
    ...mapGetters('certification', ['allCertifications']),
    filteredCertifications () {
      return this.allCertifications.filter(c => c.category === this.category)
    },
    selectedCertificationsLength () {
      return this.selectedCertifications?.length ?? 0
    },
    selectLabel () {
      if (typeof this.label === 'string') return this.label
      switch (this.category) {
        case 0:
          return this.$t('tractCertifications')
        case 1:
          return this.$t('accountCertifications')
        default:
          return this.$t('certifications')
      }
    },

    getMenuContentClass () {
      return this.elementId ? `${this.elementId}-certification-selection-menu` : 'certification-selection-menu'
    }
  },

  watch: {
    propCertifications () {
      this.selectedCertifications = this.filteredCertifications.filter(cert => this.propCertifications.some(pc =>
        ((this.useIdOnly) ? pc : pc.certificationId) === cert.certificationId))
    },

    selectedCertificationsLength () {
      this.$emit('certifications', (this.useIdOnly) ? this.selectedCertifications.map(c => c.certificationId) : this.selectedCertifications)
    }
  },

  async created () {
    await this.getCertifications()
  },

  methods: {
    ...mapActions('certification', ['fetchCertifications']),

    async getCertifications () {
      if (this.propFetchCertifications) await this.fetchCertifications()
      this.selectedCertifications = this.filteredCertifications.filter(cert => this.propCertifications.some(pc =>
        ((this.useIdOnly) ? pc : pc.certificationId) === cert.certificationId))
    }
  }
}
</script>
